import { EllipsisOutlined } from '@ant-design/icons'
import { BrokerList } from '@insurance/api/requests'
import { BrokerStatus } from '@insurance/types'
import { ConditionalText, DateTimeCell } from '@shared/components'
import { getFullName } from '@shared/utils'
import { Button, Dropdown, MenuProps, Tag, Typography } from 'antd'
import { ColumnProps } from 'antd/es/table'
import { TFunction } from 'i18next'

export const getTableColumns = (
  getActionColumnMenu: (data: BrokerList) => MenuProps['items'],
  t: TFunction,
  options?: { onNameClick?: (broker: BrokerList) => void }
): Array<ColumnProps<BrokerList>> => {
  return [
    {
      title: t('company_name'),
      dataIndex: 'name',
      key: 'name',
      sorter: true,

      render: (name, broker) =>
        options?.onNameClick ? (
          <Typography.Link onClick={() => options?.onNameClick?.(broker)}>
            {name}
          </Typography.Link>
        ) : (
          name
        )
    },
    {
      title: t('email'),
      dataIndex: 'email',
      key: 'email'
    },
    {
      title: t('administrator'),
      dataIndex: 'admin',
      key: 'admin',
      render: (user) => getFullName(user)
    },
    {
      title: t('idno'),
      dataIndex: 'idno',
      key: 'idno',
      sorter: true
    },
    {
      title: t('legal_address'),
      dataIndex: 'address',
      key: 'address',
      sorter: true
    },
    {
      title: t('iban_premiums'),
      dataIndex: 'iban',
      key: 'iban',
      sorter: true
    },
    {
      title: t('iban_commissions'),
      dataIndex: 'iban_commission',
      key: 'iban_commission',
      sorter: true,
      render: (iban) => (
        <ConditionalText condition={!!iban}>{iban}</ConditionalText>
      )
    },
    {
      title: t('status'),
      dataIndex: 'status',
      key: 'status',
      sorter: true,

      render: (status) => {
        const colors = {
          [BrokerStatus.ACTIVE]: 'green',
          [BrokerStatus.INACTIVE]: 'red',
          [BrokerStatus.PENDING_EMAIL]: 'yellow',
          [BrokerStatus.DRAFT]: 'default'
        }

        return <Tag color={colors[status as BrokerStatus]}>{t(status)}</Tag>
      }
    },
    {
      title: t('created_at'),
      dataIndex: 'created',
      key: 'created',
      sorter: true,

      render: (date) => <DateTimeCell date={date} />
    },
    {
      title: t('modified_at'),
      dataIndex: 'modified',
      key: 'modified',
      sorter: true,

      render: (date) => <DateTimeCell date={date} />
    },
    {
      title: '',
      dataIndex: '',
      key: 'actions',
      fixed: 'right',
      width: 50,
      align: 'right',
      render: (_, item) => (
        <Dropdown
          placement="bottomRight"
          trigger={['click']}
          menu={{ items: getActionColumnMenu(item) }}
        >
          <Button icon={<EllipsisOutlined />} />
        </Dropdown>
      )
    }
  ]
}
